import { PureComponent } from 'react';
import { Main } from '../pages/Main';

export class App extends PureComponent {
  render() {
    return <Main />;
  }
}
